import { render, staticRenderFns } from "./dyLiveData.vue?vue&type=template&id=08b235e8&scoped=true&"
import script from "./dyLiveData.vue?vue&type=script&lang=js&"
export * from "./dyLiveData.vue?vue&type=script&lang=js&"
import style0 from "./dyLiveData.vue?vue&type=style&index=0&id=08b235e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b235e8",
  null
  
)

export default component.exports